export default "__VITE_ASSET__BVad4gnk__"